import { NotFound } from 'component/errors/not-found';
import { questionModuleQuery, useModule } from 'system/structure-modules';
import { useEnabledFeatures } from 'util/features-hooks';

export default function SpacePromptHistoryScreen() {
    const { ThoughtProvokingPromptHistory } = useModule(questionModuleQuery);
    const { conversationhelper, conversationhelper_history } = useEnabledFeatures();
    if (!conversationhelper || !conversationhelper_history) {
        return <NotFound />;
    }

    return <ThoughtProvokingPromptHistory />;
}
